import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import {ProductStyle, SliderStyle} from './../../../../styles'
// import { fetchPage } from './../../../../services/ApiController'
import { FlickitySlider, ReturnButton, BookmarkButton, PDFButton, Arrow  } from './../../../../components'
import ProductNav from './ProductNav'
import { withResize } from './../../../../hoc/withResize'
import { withLoader } from './../../../../hoc/withLoader'
import { BaseTemplate,
  FullTextTemplate,
  IntroTemplate,
  SingleVideoTemplate,
  SliderTemplate,
  SocialTemplate,
  SuggestTemplate,
  VideoTemplate } from './ProductTemplates'


class Product extends Component {
  state = {
    active: 0,
    ready: false,
    subtitle: '',
    isBrand: false,
    // data: [],
  }

  componentDidMount() {
    document.body.classList.add('nofooter')
    this.isBrand(this.props.location)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    document.body.classList.remove('nofooter')
  }

  componentWillReceiveProps({location, data}){
    if (location.pathname !== this.props.location.pathname) {
      this.setState({
        ready: false
      })
      this.isBrand(location)
    }
    
    if (data !== this.props.data) {
      this.timer = setTimeout(() => {
        this.setState({
          data,
          active: 0,
          ready: true,
        })
      }, 400)
    }
  }

  isBrand = (location) => {
    const locationSplit = location.pathname.split('/')
    this.setState({ isBrand: locationSplit.indexOf('brand') !== -1 })
  }

  updateSlides = (index) => {
    if (index !== this.state.active) {
      this.setState({ active: index })
    }
  }

  render () {
    const { active, data, ready, isBrand} = this.state
    const { viewport } = this.props
    return (
      <div>
        {
          data && (
          <div className={`${ProductStyle( data && data.summary ? data.summary.length : 0, ready, active+1, data && data.pdfs && data.pdfs.length > 0 )}`}>
            {
              <div className='product'>
                <div className='product-nav flex'>
                  <ReturnButton big />
                  <ProductNav panels={data} callback={this.updateSlides} active={active} />
                  <BookmarkButton item={{slug_bookmark: data.slug_bookmark, type: data.type}} is_bookmark={data.is_bookmark} big />
                  { data.pdfs.length > 0 && (<PDFButton big pdfs={ data.pdfs } />) }
                  { data.pdfs.length > 0 && isBrand && (
                    <div className="pdf-annotation">
                        <span>
                          Click here to download the PDF
                        </span>
                        <Arrow width={24} height={16} />
                      </div>
                    )
                  }
                </div>

                <FlickitySlider 
                  className={`${SliderStyle} product-slider`}
                  active={active}
                  callback={this.updateSlides}
                  ready={ready}
                  options={{
                    lazyLoad: 2,
                    draggable: viewport.isMobile ? true : false,
                    selectedAttraction: 0.01,
                    friction: 0.15,
                    pageDots: false,
                    prevNextButtons: false,
                  }}>
                  {
                    data.summary.map((slide, index) => (
                        <div className="product-template template flickity-slide" key={index}>
                          {
                            slide.type === 'intro' && (<IntroTemplate {...slide} category={data.category} picture_position={data.picture_position} titleProduct={data.title} picture={data.picture} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'introproduct' && (<IntroTemplate {...slide} category={data.category} titleProduct={data.title} picture={data.picture} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'textfull' && ( <FullTextTemplate {...slide.fields} subtitle={data.title} category={data.category} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'imagelandscape' && (<BaseTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'imagetext' && (<BaseTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'imagetextblack' && (<BaseTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'social' && ( <SocialTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'list' && (<SliderTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'videos' && (<VideoTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'video' && (<SingleVideoTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'push' && (<SuggestTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                          {
                            slide.type === 'pushpicture' && (<SuggestTemplate {...slide} category={data.category} subtitle={data.title} isBrand={isBrand} />)
                          }
                        </div>
                      
                    ))
                  }

                </FlickitySlider>
              </div>
            }
           </div>
          )
        }
      </div>
    )
  }
}

export default withLoader(withResize(Product))


// WEBPACK FOOTER //
// ./src/scenes/Pages/container/Product/index.js